import React from 'react'

import './styles.scss'

import backgroundImg from './img/background.png'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { weddingDate, coupleSingleName },
  buttonMessage,
  warningMessage,
  locale = 'pt-BR',
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const date = new Date(weddingDate.timestamp)
  const day = new Intl.DateTimeFormat(locale, { day: '2-digit' }).format(date)
  const month = new Intl.DateTimeFormat(locale, { month: '2-digit' }).format(
    date
  )
  const year = new Intl.DateTimeFormat(locale, { year: '2-digit' }).format(date)

  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'já se casaram'
      : 'vão se casar'

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro238">
      <div className="intro238desktop anima-screen">
        <img src={background || backgroundImg} className="mainbackground" />
        <div className="mask-C61RwL"></div>
        <div className="anima-container-center-horizontal">
          <div className="button-C61RwL">
            <div
              className="site-de-casamento-e-xHxYv9"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-xHxYv9" role="button" onClick={onSkipIntro}>
              <div className="pular-introdu347343o-kA8htT">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="anima-container-center-horizontal">
          <div className="content-C61RwL">
            <div className="date-background-xUsx1L bp1-intro238-anima-animate-enter">
              {locale === 'en-US' ? (
                <>
                  {month}
                  <br />
                  {day}
                  <br />
                  {year}
                </>
              ) : (
                <>
                  {day}
                  <br />
                  {month}
                  <br />
                  {year}
                </>
              )}
            </div>
            <div className="v343o-se-casar-xUsx1L font-class-1 bp1-intro238-anima-animate-enter1">
              {text}
            </div>
            <div className="notranslate couple-single-namebr-xUsx1L font-class-1 bp1-intro238-anima-animate-enter2">
              {coupleSingleName.bride}{' '}
              {!!coupleSingleName.groom && `& ${coupleSingleName.groom}`}
            </div>
          </div>
        </div>
      </div>
      <div className="intro238mobile anima-screen">
        <img src={background || backgroundImg} className="mainbackground" />
        <div className="mask-C61RwL"></div>
        <div className="anima-container-center-horizontal">
          <div className="button-C61RwL">
            <div
              className="site-de-casamento-e-xHxYv9"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-xHxYv9" role="button" onClick={onSkipIntro}>
              <div className="pular-introdu347343o-kA8htT">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="anima-container-center-horizontal">
          <div className="content-C61RwL">
            <div className="anima-container-center-horizontal">
              <div className="date-background-xUsx1L bp2-intro238-anima-animate-enter">
                {locale === 'en-US' ? (
                  <>
                    {month}
                    <br />
                    {day}
                    <br />
                    {year}
                  </>
                ) : (
                  <>
                    {day}
                    <br />
                    {month}
                    <br />
                    {year}
                  </>
                )}
              </div>
            </div>
            <div className="v343o-se-casar-xUsx1L font-class-1 bp2-intro238-anima-animate-enter1">
              {text}
            </div>
            <div className="notranslate couple-single-namebr-xUsx1L font-class-1 bp2-intro238-anima-animate-enter2">
              {coupleSingleName.bride}{' '}
              {!!coupleSingleName.groom && `& ${coupleSingleName.groom}`}
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
